import { PageStore, ReducerAction } from 'app-redux/types/storeTypes';
import * as types from 'app-redux/types/actionTypes';

const initialState: PageStore = {
  pages: {},
  slug: '',
};

const reducer = (state = initialState, { payload, type }: ReducerAction) => {
  switch (type) {
    case types.SET_PAGES:
      return {
        ...state,
        pages: {
          ...state.pages,
          [payload.key]: payload.value,
        },
        slug: payload.key,
      };
    case types.SET_SLUG:
      return {
        ...state,
        slug: payload,
      };
    default: return state;
  }
};

export default reducer;
